(function() {
    'use strict';

    angular
        .module('masterApp')
        .controller('InventoryStatusDetailController', InventoryStatusDetailController);
//    InventoryStatusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils', 'InventoryStatus'];
//
//    function InventoryStatusDetailController($scope, $rootScope, $stateParams, DataUtils, InventoryStatus) {
//    	var vm = this;
//        vm.inventoryStatus1 = [{code:'I01',description:'Đủ sử dụng', note:'Tổng SL tồn > = Định mức(ĐM) tồn tối thiểu',status:'1'},
//                              {code:'I02',description:'Đặt hàng', note:'½ ĐM tồn tối thiểu < = Tổng SL tồn < ĐM tồn tối thiểu',status:'1'},
//                              {code:'I03',description:'Khẩn Cấp', note:'Tổng SL tồn < = ½ ĐM tồn tối thiểu',status:'1'}];
//        vm.inventoryStatus = vm.inventoryStatus1[0];

    InventoryStatusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils', 'entity', 'InventoryStatus'];

    function InventoryStatusDetailController($scope, $rootScope, $stateParams, DataUtils, entity, InventoryStatus) {
        var vm = this;

        vm.inventoryStatus = entity;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        if(vm.inventoryStatus.status == 1){
        	vm.inventoryStatus.statusName = 'Đang hoạt động'
        }else{
        	vm.inventoryStatus.statusName = 'Ngừng hoạt động'
        }
        var unsubscribe = $rootScope.$on('setupApp:inventoryStatusUpdate', function(event, result) {
            vm.inventoryStatus = result;
            
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
